(function () {
  "use strict";

  var ROUTES = (window.theme && window.theme.routes) || {};
  var ADD_URL = ROUTES.cartAdd || "/cart/add.js";
  var RESET_MS = 2200;

  /* ---------- Direct toevoegen aan winkelwagen ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-qa-add]") : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled || btn.classList.contains("is-loading") || btn.classList.contains("is-added")) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    /* Abonnementsproducten (requires_selling_plan) hebben een selling_plan
       nodig, anders weigert Shopify de add-to-cart met een 422. */
    var sellingPlanId = btn.getAttribute("data-selling-plan-id");
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

    var label = btn.querySelector(".qa__label");
    var original = label ? label.textContent : "";

    setLoading(btn, true);

    fetch(ADD_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (d) {
            throw new Error((d && d.description) || "add_failed");
          });
        }
        return res.json();
      })
      .then(function () {
        setLoading(btn, false);
        btn.classList.add("is-added");
        if (label) label.textContent = "Toegevoegd";
        showCartDot();
        refreshThemeCart();
        window.setTimeout(function () {
          btn.classList.remove("is-added");
          if (label) label.textContent = original;
        }, RESET_MS);
      })
      .catch(function (err) {
        setLoading(btn, false);
        if (label) label.textContent = "Probeer opnieuw";
        window.setTimeout(function () {
          if (label) label.textContent = original;
        }, RESET_MS);
        if (window.console && console.error) console.error("[quick-add]", err);
      });
  });

  /* ---------- Cart verversen na quick-add ----------
     Het Motion-thema rendert de drawer-inhoud client-side vanuit een
     intern cart-object. Een directe fetch naar /cart/add.js werkt dat
     object niet bij, waardoor de drawer pas na een refresh klopt.
     We halen de verse cart op en laten het thema opnieuw renderen via
     de events die Motion / Archetype gebruikt. We proberen meerdere
     bekende hooks zodat het werkt ongeacht de exacte themaversie. */
  function refreshThemeCart() {
    var CART_URL = ROUTES.cart || "/cart.js";
    fetch(CART_URL, { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // 1) Archetype/Motion CartJS-stijl objecten
        try {
          if (window.theme && window.theme.cart && typeof window.theme.cart.buildCart === "function") {
            window.theme.cart.buildCart(cart);
          }
        } catch (e) {}

        // 2) Bekende custom events die Motion-componenten oppikken
        var detail = { cart: cart };
        dispatch(document, "cart:updated", detail);
        dispatch(document, "cart:build", detail);
        dispatch(document, "cart:refresh", detail);
        dispatch(document, "ajaxProduct:added", detail);
        dispatch(document, "product:added", detail);

        // 3) Shopify standaard pub/sub (indien aanwezig)
        try {
          if (window.Shopify && window.Shopify.PubSub && typeof window.Shopify.PubSub.publish === "function") {
            window.Shopify.PubSub.publish("cart-update", { cart: cart });
          }
        } catch (e) {}

        // 4) Werk zichtbare onderdelen direct bij als fallback
        updateCartCount(cart);
        updateDrawerSubtotal(cart);
      })
      .catch(function () {});
  }

  function dispatch(target, name, detail) {
    var evt;
    try {
      evt = new CustomEvent(name, { bubbles: true, detail: detail });
    } catch (e) {
      evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(name, true, true, detail);
    }
    target.dispatchEvent(evt);
  }

  function updateCartCount(cart) {
    var count = cart && typeof cart.item_count === "number" ? cart.item_count : null;
    if (count === null) return;
    var nodes = document.querySelectorAll(".cart-link__bubble-num, [data-cart-count], .cart-count");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
    }
  }

  function updateDrawerSubtotal(cart) {
    if (!cart) return;
    var nodes = document.querySelectorAll("[data-subtotal]");
    var formatted = formatMoney(cart.total_price);
    for (var i = 0; i < nodes.length; i++) {
      if (formatted) nodes[i].innerHTML = formatted;
    }
  }

  function formatMoney(cents) {
    if (typeof cents !== "number") return null;
    try {
      var euros = (cents / 100).toFixed(2).replace(".", ",");
      return "&euro;" + euros;
    } catch (e) { return null; }
  }

  function setLoading(btn, on) {
    if (on) {
      btn.classList.add("is-loading");
      btn.setAttribute("aria-busy", "true");
      btn.disabled = true;
    } else {
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    }
  }

  function showCartDot() {
    var dots = document.querySelectorAll(".cart-link__bubble");
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.add("cart-link__bubble--visible");
    }
  }

  /* ---------- Gelijke kaarthoogtes per rij ---------- */
  function directContent(card) {
    for (var n = card.firstElementChild; n; n = n.nextElementSibling) {
      if (n.classList && n.classList.contains("grid-product__content")) return n;
    }
    return null;
  }

  function equalizeRows() {
    var cards = document.querySelectorAll(".grid-product");
    if (!cards.length) return;

    var contents = [];
    var i, j;
    for (i = 0; i < cards.length; i++) {
      var content = directContent(cards[i]);
      if (content) {
        content.style.minHeight = "";
        contents.push(content);
      }
    }

    var rows = [];
    var keys = {};
    for (i = 0; i < contents.length; i++) {
      var card = contents[i].parentNode;
      var top = Math.round(card.getBoundingClientRect().top + window.pageYOffset);
      var key = String(top);
      if (keys[key] === undefined) {
        keys[key] = rows.length;
        rows.push([]);
      }
      rows[keys[key]].push(contents[i]);
    }

    for (i = 0; i < rows.length; i++) {
      var group = rows[i];
      var max = 0;
      for (j = 0; j < group.length; j++) {
        var h = group[j].offsetHeight;
        if (h > max) max = h;
      }
      if (group.length > 1 && max > 0) {
        for (j = 0; j < group.length; j++) {
          group[j].style.minHeight = max + "px";
        }
      }
    }
  }

  var rafId;
  function scheduleEqualize() {
    if (rafId) window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(equalizeRows);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      window.clearTimeout(t);
      t = window.setTimeout(fn, wait);
    };
  }

  function init() {
    scheduleEqualize();
    window.setTimeout(scheduleEqualize, 300);
    window.setTimeout(scheduleEqualize, 1000);

    window.addEventListener("load", scheduleEqualize);
    window.addEventListener("resize", debounce(scheduleEqualize, 150));
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleEqualize);
    }

    var ajax = document.getElementById("CollectionAjaxContent") ||
      document.querySelector("[data-section-type='collection-template']");
    if (ajax && window.MutationObserver) {
      var mo = new MutationObserver(debounce(scheduleEqualize, 150));
      mo.observe(ajax, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();